import { z } from "zod";

/** Shared metadata for an AI-enabled command. */
export interface CopilotCommandMeta<
  TSchema extends z.ZodObject<z.ZodRawShape> = z.ZodObject<z.ZodRawShape>
> {
  /** Unique name, used as both command ID and AI tool name */
  toolName: string;
  /** Human-readable title for command */
  title: string;
  /** Used in both command and AI tool schema */
  description: string;
  /** Zod schema for input, defines both AI tool params and AI command args */
  inputSchema: TSchema;
}

export function defineCopilotCommandMeta<
  TSchema extends z.ZodObject<z.ZodRawShape>
>(meta: CopilotCommandMeta<TSchema>): CopilotCommandMeta<TSchema> {
  return meta;
}

export const COPILOT_COMMANDS = {
  insertHtml: defineCopilotCommandMeta({
    toolName: "insertHtml",
    title: "Insert HTML",
    description: "Insert an HTML/CSS snippet",
    inputSchema: z.object({
      html: z.string().describe("The HTML snippet to be inserted"),
      targetTplUuid: z
        .string()
        .optional()
        .describe(
          "UUID of the target element to insert into or next to. Defaults to the currently focused element or the root."
        ),
      insertRelLoc: z
        .enum(["before", "prepend", "append", "after", "wrap"])
        .optional()
        .describe(
          `Where to insert relative to the target element. Defaults to auto-determined based on valid insertion locations.
before: as a sibling before the target.
after: as a sibling after the target.
prepend: as the first child of the target.
append: as the last child of the target.
wrap: wrap the target inside the new element.`
        ),
    }),
  }),
} as const;
